import { Link } from "react-router-dom";

const FOOTER_LINKS = [
  { label: "Features", to: "/#features" },
  { label: "Pricing", to: "/pricing" },
  { label: "Sign up", to: "/signup" },
  { label: "Log in", to: "/login" },
  { label: "Reset password", to: "/forgot-password" },
];

const Footer = () => (
  <footer className="border-t border-slate-200/80 bg-white">
    <div className="max-w-6xl mx-auto px-4 lg:px-8 py-10">
      <div className="flex flex-col gap-8 sm:flex-row sm:items-start sm:justify-between">
        <div className="max-w-xs">
          <a href="/" className="inline-flex items-center gap-2.5">
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-gradient-to-br from-[#0BBF64] to-emerald-600 text-sm font-bold text-white">
              A
            </span>
            <span className="font-extrabold text-lg tracking-tight text-slate-900">
              Astudent
            </span>
          </a>
          <p className="mt-3 text-sm leading-relaxed text-slate-500">
            AI project documentation for Nigerian students — from topic ideas to
            supervisor-ready chapters.
          </p>
        </div>

        <ul className="flex flex-wrap gap-x-6 gap-y-2 text-sm">
          {FOOTER_LINKS.map((link) => (
            <li key={link.to}>
              {link.to.startsWith("/#") ? (
                <a
                  href={link.to}
                  className="font-medium text-slate-600 transition hover:text-slate-900"
                >
                  {link.label}
                </a>
              ) : (
                <Link
                  to={link.to}
                  className="font-medium text-slate-600 transition hover:text-slate-900"
                >
                  {link.label}
                </Link>
              )}
            </li>
          ))}
        </ul>
      </div>

      <div className="mt-8 flex flex-col gap-2 border-t border-slate-100 pt-6 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-xs text-slate-400">
          &copy; {new Date().getFullYear()} Astudent. All rights reserved.
        </p>
        <p className="text-xs text-slate-400">
          Built for Nigerian universities &amp; polytechnics.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
